/**
 * Values must match `industry[].english` from GET /api/business/ (filter query param).
 * Extend this list when the backend adds industries.
 */
export const MERCHANT_INDUSTRY_FILTERS = [
  {
    value: "Office Furniture",
    label_en: "Office Furniture",
    label_ar: "أثاث المكتب",
  },
  {
    value: "Home Furniture",
    label_en: "Home Furniture",
    label_ar: "أثاث المنزل",
  },
  {
    value: "Home and Kitchen Appliance",
    label_en: "Home and Kitchen Appliance",
    label_ar: "أجهزة المنزل والمطبخ",
  },
  {
    value: "Kitchen",
    label_en: "Kitchen",
    label_ar: "مطبخ",
  },
  {
    value: "Other",
    label_en: "Other",
    label_ar: "أخرى",
  },
]
